var React = require('react');

function ArrowsAltH (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M134.1 216H378v80H134.1z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M378 170v172c0 21.41 25.88 32.1 41 17l86-86a24 24 0 0 0 0-33.94L419 153c-15.17-15-41-4.36-41 17zM134.1 342V170.11c0-21.41-25.88-32.1-41-17l-86.1 86A24 24 0 0 0 7 273l86.1 86c15.15 15.06 41 4.37 41-17z","className":"fa-primary","key":2})]);
}

ArrowsAltH.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = ArrowsAltH;

ArrowsAltH.default = ArrowsAltH;
